export default "__VITE_ASSET__DathreUc__"